export const ACCOUNT_GET_V2 = "/api/v2/account/get";
export const ACCOUNT_UPDATE_V2 = "/api/v2/account/update";
export const ACCOUNT_ONBOARDING_GET_V2 = "/api/v2/account/onboarding/get";
export const BOARD_POD_GET_V2 = "/api/v2/board/pod/get";
export const BOARD_MANE_SET_V2 = "/api/v2/board/name/set";
export const BOARD_IMAGE_COPY = "/api/board/image/copy";
export const BOARD_ZOOM_SET_V2 = "/api/v2/board/zoom/set";
export const BOARD_ZOOM_GET_V2 = "/api/v2/board/zoom/get";
export const BOARD_SHARE_LINK_ACCESS_PASSWORD_APPLY_V2 =
    "/api/v2/board/share/link/access/password/apply";
export const BOARD_SHARE_LINK_ACCESS_PASSWORD_GET_V2 =
    "/api/v2/board/share/link/access/password/get";
export const BOARD_SHARE_LINK_ACCESS_PASSWORD_SET_V2 =
    "/api/v2/board/share/link/access/password/set";
export const BOARD_SHARE_GET_V2 = "/api/v2/board/share/get";
export const BOARD_ACCESS_GET_V2 = "/api/v2/board/access/get";
export const BOARD_SHARE_TEAM_ACCESS_SET = "/api/v2/board/share/team/access/set";
export const BOARD_SHARE_LINK_ACCESS_SET_V2 = "/api/v2/board/share/link/access/set";
export const BOARD_MEMBERS_DELETE_V2 = "/api/v2/board/members/delete";
export const BOARD_MEMBERS_ACCESS_SET_V2 = "/api/v2/board/members/access/set";
export const BOARD_MEMBERS_ADD_V2 = "/api/v2/board/members/add";
export const BOARD_META_FAVOURITE_SET_V2 = "/api/v2/board/meta/favourite/set";
export const TEAM_MEMBERS_FIND_V2 = "/api/v2/team/members/find";
export const PROJECT_ACCESS_GET_V2 = "/api/v2/project/access/get";
export const PROJECT_SHARE_GET_V2 = "/api/v2/project/share/get";
export const PROJECT_MEMBERS_DELETE_V2 = "/api/v2/project/members/delete";
export const PROJECT_MEMBERS_ACCESS_SET_V2 = "/api/v2/project/members/access/set";
export const PROJECT_MEMBERS_ADD_V2 = "/api/v2/project/members/add";
export const PROJECT_NAME_SET_V2 = "/api/v2/project/name/set";
export const PROJECT_REMOVE_V2 = "/api/v2/project/remove";
export const TEMPLATE_LIST_V2 = "/api/v2/template/list";
